import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';

import { FormController, Heading } from '@dreryk/react-components';
import { FormContextValues } from '@dreryk/react-common';

import { protectFeature } from '~libs.shared.system';
import {
   MedicineActiveIngredients,
   MedicineName,
   MedicinePackage,
   MedicineSafetyIndicators,
} from '~libs.desktop.shared.medicine';

import { visitTranslationKeys } from '../../../../../translations';

import { WithdrawnMedicineFieldFormBeanPart } from './WithdrawnMedicineField.types';
import { StyledWithdrawnMedicineField } from './WithdrawnMedicineField.styled';

type WithdrawnMedicineFieldProps = Pick<FormContextValues<WithdrawnMedicineFieldFormBeanPart>, 'register'>;

export const WithdrawnMedicineField = (props: WithdrawnMedicineFieldProps): JSX.Element => {
   return (
      <FormController<MedicineSimple> controller={props.register('withdrawnMedicine')}>
         {({ value: medicine }) => {
            return (
               <div>
                  <Heading
                     testId={'medicineWithdrawn'}
                     type={'h2'}
                     content={visitTranslationKeys.common.medicineWithdrawn}
                     margin={'0px'}
                  />
                  <StyledWithdrawnMedicineField>
                     <div>
                        <MedicineName name={medicine.fullName} atc={medicine.atc} />
                        <MedicineActiveIngredients activeIngredients={medicine.activeIngredients} />
                     </div>
                     {protectFeature(
                        'extendedMedicineDatabase',
                        <MedicineSafetyIndicators medicineId={medicine.id} />,
                        <div />
                     )}
                     <MedicinePackage
                        form={medicine.form}
                        dose={medicine.dose}
                        packageContent={medicine.packageContent}
                     />
                  </StyledWithdrawnMedicineField>
               </div>
            );
         }}
      </FormController>
   );
};
